import { auroraBaseColors, auroraDarkThemeColors, auroraLightThemeColors } from './auroraColors'
import { baseColors, ThemeColors } from './colors'

/**
 * Lyra Connect color overrides extending Aurora theme.
 * Only overrides specific tokens that differ from Aurora.
 */
export const connectLightThemeColors: ThemeColors = {
  ...auroraLightThemeColors,

  // Background - Connect uses white background for sidebar/primary areas
  backgroundPrimary: baseColors.white,
  // backgroundSection - neutral light gray for section cards
  backgroundSection: '#F8F8F8',
  // backgroundSecondary - neutral gray for striped table rows and secondary backgrounds
  backgroundSecondary: '#F8F8F8',
  // backgroundElement - neutral gray for cards on blue backgrounds
  backgroundElement: baseColors.oatmeal_15,

  // textSecondary - Connect uses a darker secondary text color per Figma
  textSecondary: '#464E61',

  // Highlight - amber background for search highlight matches
  backgroundHighlightSecondary: '#f3b962',

  // Badge - cobalt_50 matches the Figma counter badge color (#1F579E)
  backgroundBadge: auroraBaseColors.cobalt_50,

  // Border - Override for visibility on white backgrounds
  borderDefault: baseColors.oatmeal_30,
  borderInput: baseColors.teal_40,

  // Gradient colors for header sections (article pages, etc.)
  backgroundGradientFirst: auroraBaseColors.cobalt_20,
  backgroundGradientSecond: auroraBaseColors.gradient_background_blend,

  // Logo - Connect uses dark navy logo
  icons: {
    ...auroraLightThemeColors.icons,
    lyraLogoPrimaryIcon: {
      fill: auroraBaseColors.cobalt_75,
    },
  },
}

export const connectDarkThemeColors: ThemeColors = {
  ...auroraDarkThemeColors, // TBD
}
